/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leaderboard_Pr_Type_MaxrepsInputs */

const fr_leaderboard_pr_type_maxreps = /** @type {(inputs: Leaderboard_Pr_Type_MaxrepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répétitions Max`)
};

/**

* @param {Leaderboard_Pr_Type_MaxrepsInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const leaderboard_pr_type_maxreps = /** @type {((inputs?: Leaderboard_Pr_Type_MaxrepsInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leaderboard_Pr_Type_MaxrepsInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_leaderboard_pr_type_maxreps(inputs)
});